import { TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID } from '@solana/spl-token';

/** @group Programs */
const tokenProgram = {
  name: 'TokenProgram',
  address: TOKEN_PROGRAM_ID
};

/** @group Programs */
const associatedTokenProgram = {
  name: 'AssociatedTokenProgram',
  address: ASSOCIATED_TOKEN_PROGRAM_ID
};

export { associatedTokenProgram, tokenProgram };
//# sourceMappingURL=program.mjs.map
